// #MODULE - CacheManager
// ##DESCRIPTION: This module will handle getting, setting, and removing items from the cache
let sessionStore;
let localStore;
const EXP = 'Exp';

function get(storage, key) {
  let value = null;
  const now = new Date();
  let exp = storage.getItem(key + EXP) || storage.getItem(`${key}_exp`);

  if (exp) {
    exp = new Date(exp);
    if (exp > now) {
      value = storage.getItem(key);
    } else {
      storage.removeItem(key);
    }
  } else {
    value = storage.getItem(key);
  }
  if (JSON && value) {
    // not all results are JSON!
    try {
      value = JSON.parse(value);
    } catch (e) {
      // Logger.log('Failed parsing JSON: ', e);
    }
  }

  return value;
}

function set(storage, key, dataObj, expiration) {
  if (storage) {
    let data = dataObj;
    if (JSON) {
      data = JSON.stringify(data);
    }

    storage.setItem(key, data);
    if (expiration) {
      const now = new Date();
      // Convert minutes to milliseconds
      const exp = new Date(now.getTime() + (expiration * 60 * 1000));
      storage.setItem(key + EXP, exp);
    }
  }
}

// ### Method - getSession(key) public method to get value from the session cache for the specified key
//
// > parameters
// >
// + *key* - the key used to retrieve the data from the cache
//
// > returns
// >
// + The data from the cache for the specified key or null
function getSession(key) {
  if (sessionStore) {
    return get(sessionStore, key);
  }
  // Handled when cache is cleared empty value is stored in session storage
  return null;
}

// Method to sessionStore the result suggestions into the cache
//
// > parameters
// >
// + *key* - the key to store in the cache
// + *data* - that data to store in the cache
// + *expiration* - (optional) minutes from the current time when the cache will expire
function setSession(key, data, expiration = null) {
  set(sessionStore, key, data, expiration);
}

// Method to remove from sessionStore the item with the respective key
//
// > parameters
// >
// + *key* - the key to remove from cache
function removeSession(key) {
  sessionStore.removeItem(key);
  sessionStore.removeItem(key + EXP);
}

// Method to clear sessionStorage object
function clearSession() {
  sessionStore.clear();
}

// ### Method - getPersistent(key) public method to get value from the persistent cache for the specified key
//
// > parameters
// >
// + *key* - the key used to retrieve the data from the cache
//
// > returns
// >
// + The data from the cache for the specified key or null
function getPersistent(key) {
  if (localStore) {
    return get(localStore, key);
  }
  // Handled when cache is cleared empty value is stored in session storage
  return null;
}

// ###Method - setPersistent(key, data, expiration) public method to set a persistent cache
//
// > parameters
// >
// + *key* - the key to store in the cache
// + *data* - that data to store in the cache
// + *expiration* - (optional) minutes from the current time when the cache will expire
function setPersistent(key, data, expiration) {
  set(localStore, key, data, expiration);
}

// Method to remove from localStore the item with the respective key
//
// > parameters
// >
// + *key* - the key to remove from cache
function removePersistent(key) {
  localStore.removeItem(key);
  localStore.removeItem(key + EXP);
}

// Method to clear localStore object
function clearPersistent() {
  localStore.clear();
}

function initCacheStores() {
  if (typeof Storage !== 'undefined') {
    sessionStore = sessionStorage;
    localStore = localStorage;
  }
}
initCacheStores();

module.exports = {
  getSession,
  getPersistent,
  setSession,
  clearSession,
  clearPersistent,
  setPersistent,
  removeSession,
  removePersistent,
};
